/**
 * Linkify — renders plain text with URLs auto-converted to clickable <a> tags.
 * Safe against XSS because we never use dangerouslySetInnerHTML; we build React
 * children manually. Supports http(s)://, www., and bare domains (foo.com).
 */
const URL_RE = /(\bhttps?:\/\/[^\s<>"')]+|\bwww\.[^\s<>"')]+|\b[a-z0-9][a-z0-9-]+(?:\.[a-z]{2,})+(?:\/[^\s<>"')]*)?)/gi;

export default function Linkify({ text, className = "" }) {
  if (!text) return null;
  const parts = [];
  let last = 0;
  let match;
  const re = new RegExp(URL_RE);
  while ((match = re.exec(text)) !== null) {
    const url = match[0];
    // Skip false-positives: only strings with a dot and no trailing invalid chars
    if (!url.includes(".")) continue;
    if (match.index > last) parts.push(text.slice(last, match.index));
    let href = url;
    if (!/^https?:\/\//i.test(href)) href = `https://${href}`;
    parts.push(
      <a
        key={`${match.index}-${url}`}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="text-[#00e5ff] hover:text-[#00e5ff] underline decoration-[#00e5ff]/40 underline-offset-2 hover:decoration-[#00e5ff] break-all"
        onClick={(e) => e.stopPropagation()}
      >
        {url}
      </a>
    );
    last = match.index + url.length;
  }
  if (last < text.length) parts.push(text.slice(last));
  return <span className={className}>{parts}</span>;
}
